import _ from 'lodash';
import { Injectable } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ImportImageService {

  constructor(
  ) { }

  getImageUrlObj(value, key) {
    const fileName = _.get(value, 'file.name', '');
    const blobUrl = _.get(value, 'blob.url', '');
    return {
      name: _.isObject(value) ? fileName || blobUrl : value,
      found: false,
      key
    };
  }

  getImages(options: UntypedFormArray) {
    return _.chain(options.value).map((option, key) => {
        const vImageUrl = this.getImageUrlObj(option.vImageUrl, key);

        const vAdditionalImages = _.map(option.vAdditionalImages, (vAdditionalImage) => {
          return this.getImageUrlObj(vAdditionalImage, key);
        });

        const vImageUrls = _.map(option.vImageUrls, (vImageUrl) => {
          return this.getImageUrlObj(vImageUrl, key);
        });

        const thumbnailUrl = this.getImageUrlObj(option.thumbnailUrl, key);

        return [vImageUrl, vAdditionalImages, vImageUrls, thumbnailUrl];
      }).flattenDeep().reject((image) => {
        return _.isEmpty(image.name);
      }).uniqBy('name').value();
  }

  getImageUrls(images: any[]) {
      return _.sumBy(images, ({ name }) => {
          if(name === '/images/blank_2x1.png' || name === '/images/blank_1x1.png') {
            return 0;
          }
          try {
            new URL(name);
            return 1;
          } catch(e) {}
          return 0;
      });
  }

  getLocalImages(images: any[]) {
    return _.sumBy(images, ({ name }) => {
        if(name === '/images/blank_2x1.png' || name === '/images/blank_1x1.png') {
          return 0;
        }
        try {
          new URL(name);
          return 0;
        } catch(e) {}
        return 1;
    });
  }
}